
import TalkCommon from './index.vue'

TalkCommon.install = function (Vue) {
  Vue.component(TalkCommon.name, TalkCommon)
}

export default TalkCommon